<template>
  <div>
    <el-dialog
      class="createTaskDialog"
      top="0px"
      width="1000px"
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="cancelDialog"
    >
      <div class="typeTitle" style="text-align: center;margin-bottom: 10px;">
        <el-radio-group v-model="newTaskType" style="margin-bottom: 20px;">
          <el-radio-button label="简版事项"></el-radio-button>
          <el-radio-button label="复杂事项"></el-radio-button>
        </el-radio-group>
      </div>
      <el-form
        :model="createTaskMeg"
        ref="ruleForm"
        :rules="rules"
        width="980px"
        class="createTaskForm demo_ruleForm"
        label-position="right"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" label-width="100px" prop="taskName">
              <!--            <selectKnowledge @getValue="getValueSelectKnowledge"></selectKnowledge>-->
              <el-input placeholder="请描述您的问题" v-model="createTaskMeg.taskName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col style="display: none;">
            <el-form-item label="任务类型" label-width="100px" prop="taskType">
              <el-select
                style="width: 100%;"
                v-model="createTaskMeg.taskType"
                placeholder="请选择类型"
                @change="taskTypeChange"
              >
                <el-option
                  v-for="item in taskTypeList "
                  :key="item.ID "
                  :label="item.NAME "
                  :value="item.ID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="接收方" label-width="100px" :prop="ReceiverProp" class="rightPadding">
              <ayb-select-receiver
                ref="ReceiveUser"
                :isRadio="true"
                setWidth="100%"
                @getValue="receiverGetValue"
              ></ayb-select-receiver>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建科室" label-width="100px" class="rightPadding">
              <el-select
                v-model="createDeptId"
                style="width: 100%;"
                clearable
                placeholder="请选择"
                :loading="loading"
              >
                <el-option
                  v-for="item in createDeptOptions"
                  :key="item.ID"
                  :label="item.NAME"
                  :value="item.ID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-show="newTaskType == '复杂事项'">
          <el-row>
            <el-col :span="12">
              <el-form-item label="预计开始时间" label-width="100px" class="rightPadding">
                <el-date-picker
                  v-model="createTaskMeg.planStartDT"
                  type="datetime"
                  placeholder="选择日期时间"
                  style="width:100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
            <el-form-item label="预计完成时间" label-width="100px">
              <el-date-picker v-model="createTaskMeg.planEndDT" type="datetime" placeholder="选择日期时间" style="width:100%;"></el-date-picker>
            </el-form-item>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="预计完成时间" label-width="100px" class="rightPadding">
                <el-date-picker
                  :disabled="!createTaskMeg.isNotice"
                  type="datetime"
                  v-model="createTaskMeg.overTimeDT"
                  placeholder="请输入任务到期时间"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="text-align: right;line-height: 3;">
              <el-checkbox
                label="1"
                v-model="createTaskMeg.isNotice"
                ref="isNotice"
                @change="onNoticeChange"
                border
              >进度逾期提醒</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="8">
            <el-form-item label="首次提醒时间" label-width="100px" class="rightPadding">
              <el-input :disabled="!createTaskMeg.isRemind" v-model="createTaskMeg.firstRemindTime" placeholder="请输入首次提醒时间"
                ref="firstRemind"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-select :disabled="!createTaskMeg.isRemind" v-model="createTaskMeg.firstRemindTimeUnit" placeholder="分"
              style="width:60px;" ref="firstRemindUnit">
              <el-option label="分" value="0"></el-option>
              <el-option label="时" value="1"></el-option>
              <el-option label="天" value="2"></el-option>
            </el-select>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="接收时长" label-width="100px" class="rightPadding">
                <el-input
                  v-model="createTaskMeg.firstRemindTime"
                  placeholder="请输入接收时长"
                  ref="firstRemind"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-select
                v-model="createTaskMeg.firstRemindTimeUnit"
                placeholder="分"
                style="width:60px;"
                ref="firstRemindUnit"
              >
                <el-option label="分" value="0"></el-option>
                <el-option label="时" value="1"></el-option>
                <el-option label="天" value="2"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-form-item label="逾期提醒周期" label-width="100px">
                <el-input
                  :disabled="!createTaskMeg.isRemind"
                  v-model="createTaskMeg.overdueTime"
                  placeholder="请输入逾期提醒周期"
                  style="width:calc(100% - 65px);"
                  ref="overdue"
                ></el-input>
                <el-select
                  :disabled="!createTaskMeg.isRemind"
                  v-model="createTaskMeg.overdueTimeUnit"
                  placeholder="时"
                  style="width:60px;"
                  ref="overdueUnit"
                >
                  <el-option label="分" value="0"></el-option>
                  <el-option label="时" value="1"></el-option>
                  <el-option label="天" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="text-align:right;">
              <el-checkbox
                label="1"
                v-model="createTaskMeg.isRemind"
                ref="isRemind"
                @change="onRemindChange"
                border
                style="position:relative;top:2px;"
              >操作超期提醒</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务等级" label-width="100px" class="rightPadding">
                <el-select
                  style="width: 100%;"
                  v-model="createTaskMeg.taskLevelSel"
                  placeholder="请选择 "
                >
                  <el-option
                    v-for="item in taskLevel "
                    :key="item.value "
                    :label="item.label "
                    :value="item.value "
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关注度" label-width="100px">
                <el-select
                  v-model="createTaskMeg.focusLevelSel"
                  placeholder="请选择"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in focusLevel "
                    :key="item.value "
                    :label="item.label "
                    :value="item.value "
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="任务组" label-width="100px" class="rightPadding">
                <selectTaskGroup
                  :taskGroup="taskGroup"
                  ref="taskGroup"
                  myWidth="100%"
                  @GetTaskGroup="GetTaskGroup"
                ></selectTaskGroup>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建身份" label-width="100px">
                <el-select
                  style="width: 100%;"
                  v-model="createTaskMeg.createIdentitySel"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in createIdentity "
                    :key="item.SERVERCENTERID "
                    :label="item.CENTERNAME "
                    :value="item.SERVERCENTERID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="通知提醒人" label-width="100px" class="rightPadding">
                <ayb-select-user
                  ref="selectAllUser"
                  :isRadio="false"
                  setWidth="100%"
                  @getValue="getAllUser"
                ></ayb-select-user>
              </el-form-item>
            </el-col>
            <div>
              <el-col :span="9">
                <el-form-item label="联系人" label-width="100px" class="rightPadding">
                  <selectLinkman
                    ref="linkman"
                    setWidth="100%"
                    :isValidateMethod="false"
                    userNameString="report"
                    :isRadio="true"
                    @getValue="linkmanGetValue"
                  ></selectLinkman>
                </el-form-item>
              </el-col>
              <el-col :span="3" style="text-align: right;line-height: 3;">
                <el-checkbox v-model="createTaskMeg.isEvaluter" label="1" border>评价人</el-checkbox>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
            <el-form-item label="任务标签" label-width="100px" class="rightPadding">
              <el-select
                v-model="tagArray"
                multiple
                filterable
                allow-create
                remote
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="getTagByInput"
                :loading="loading"
              >
                <el-option
                  v-for="item in tagOptions"
                  :key="item.ID"
                  :label="item.TAGNAME"
                  :value="item.TAGNAME"
                ></el-option>
              </el-select>
            </el-form-item>
            </el-col>-->
          </el-row>
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="内容描述" label-width="100px">
              <wangeditor ref="editorTxt" v-model="createTaskMeg.content"></wangeditor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="截图" label-width="100px">
              <el-button @click="captureStart" type="primary">截图</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="截图设置" label-width="100px">
              <el-checkbox v-model="createTaskMeg.hideWindow">隐藏当前窗口</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="添加附件" label-width="100px">
              <!-- <el-upload
                class="upload-demo"
                action="http://localhost:8080"
                :limit="5"
                :on-exceed="exceedUpload"
                :auto-upload="true"
                ref="upload"
                :before-upload="beforeUpload "
                :on-change="handleChange"
                :file-list="fileList"
              >
                <el-button type="primary">添加附件</el-button>
              </el-upload>-->
              <div style="display:inline-block;margin:1px" id="CreateTaskFilePicker">上传附件</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="file-panel" :style="filePanelHeight" v-show=" fileList.length>0">
              <h2>文件列表</h2>
              <div class="file-list" :style="filePanelHeight">
                <ul
                  class="file-item"
                  :class="`file-${file.id}`"
                  v-for="(file, index) in fileList"
                  :key="index"
                >
                  <li class="file-type" :icon="fileCategory(file.ext)"></li>
                  <li class="file-name">
                    <div class="fileName">{{file.name}}</div>
                  </li>
                  <li class="file-size">{{fileSize(file.size)}}</li>
                  <li class="file-status">上传中...</li>
                  <li class="file-operate">
                    <!--<a title="开始" @click="resume(file)">
                                        <i class="el-icon-caret-right"></i>
                                    </a>
                                    <a title="暂停" @click="stop(file)">
                                        <i class="el-icon-video-pause"></i>
                    </a>-->
                    <a title="移除" @click="remove(file)">
                      <i class="el-icon-delete"></i>
                    </a>
                  </li>
                  <li class="progress"></li>
                </ul>
                <div class="no-file" v-if="!fileList.length">
                  <i class="el-icon-files"></i> 暂无待上传文件
                </div>
              </div>
              <vue-upload
                ref="uploader"
                uploadButton="#CreateTaskFilePicker"
                :isDialog="true"
                multiple
                :formData="fileFormData"
                @fileChange="fileChange"
                @progress="onProgress"
                @success="fileUploadCompleted"
              ></vue-upload>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="createTaskMeg.resolved">
          <el-col :span="24">
            <el-form-item label="解决方案" label-width="100px">
              <el-input
                type="textarea"
                :autosize="{ minRows: 3}"
                placeholder="请输入解决方案"
                v-model="createTaskMeg.solution"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <!--<el-col :span="8" style="text-align: left;">

<el-button @click="moreShow = !moreShow">查看更多</el-button>
          </el-col>-->
          <el-col :span="24" style="text-align:center">
            <el-button @click="dialogVisible=false">取 消</el-button>
            <el-button @click="reportStart" type="primary">发 送</el-button>
            <el-checkbox style="margin-left: 8px;" v-model="createTaskMeg.resolved" border>已解决</el-checkbox>
          </el-col>
        </el-row>
      </div>
      <workFlowDialog ref="workFlow" @Process="Process"></workFlowDialog>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import cap from "@/capturn/capturnwrapper.js";
import { getToken } from "../../../util/auth";
import selectKnowledge from "@/components/basicData/selectKnowledge.vue";
import selectFuncRoom from "@/components/basicData/selectFuncRoom.vue";
import selectCompanyDept from "@/components/basicData/selectCompanyDeptComponent.vue";
import selectLinkman from "@/components/basicData/selectLinkmanComponent.vue";
import selectExcuteHuman from "@/components/basicData/selectExcuteHuman.vue";
import selectTaskGroup from "@/components/basicData/selectTaskGroup.vue";
import wangeditor from "@/components/common/editor.vue";
import selectFacilityComponent from "@/components/basicData/selectFacilityComponent.vue";
import commonSelectComponent from "@/components/basicData/commonSelectComponent";
import sde from "@/components/basicData/selectDeviceExample";
import workFlowDialog from "./WorkFlowDialog.vue";
import vueUpload from "@/components/basicData/upload";
import { MergeFile, GetTaskTag } from "@/api/modules/basicData/task";
import {
  GetCustmerSchemeInfoList,
  GetDataItemTree
} from "@/api/modules/basicData/workFlow";
import {
  GetTaskTypeList,
  AddEvent,
  GetSysUserByCode,
  workflowCreate,
  AddAssignTask,
  AddAssignFileTask,
  GetCompanyAllGeneralSelTree,
  GetSelfCompanyEx,
  GetAllTaskNoticePolicy
} from "@/api/modules/basicData/task";
import { GetPubDeptByUserId } from "@/api/modules/basicData/user";
import { GetFuncRoomByCompanyId } from "@/api/modules/basicData/organization";
const cookieUser = getToken();
export default {
  name: "CreateItem",
  props: {
    taskGroup: {
      type: String,
      default: ""
    },
    noticePersons: [],
    taskTypeName: "",
    refreshType: {
      //按钮操作成功后刷新方式 0:更新列表 1：刷新页面
      type: Number,
      default: 0
    },
    groupId: {
      //群ID
      type: String,
      default: ""
    }
  },
  components: {
    selectKnowledge,
    selectFuncRoom,
    selectLinkman,
    selectExcuteHuman,
    selectCompanyDept,
    wangeditor,
    selectTaskGroup,
    selectFacilityComponent,
    commonSelectComponent,
    workFlowDialog,
    sde,
    vueUpload
  },
  data() {
    var checknum = (rule, value, callback) => {
      value = this.trim(value);
      if (!value) {
        callback(new Error("请描述您的问题"));
        this.time("ruleForm", "taskName");
      } else {
        callback();
      }
    };
    return {
      createDeptOptions: [],
      createDeptId: "",
      IsShowOnlyList: this.$route.query.type == "groupList" ? true : false,
      newTaskType: "简版事项",
      tagArray: [],
      loading: false,
      tagOptions: [],
      type1: this.$route.query.type || 2,
      isActive: false,
      isRemind: false,
      isNotice: false,
      title: "新建事项",
      ReceiverProp: "ReceiveUserName",
      workflowName: "", //固定流程名称
      type: 1, //类型（1.新建报修，2.服务申请）
      processId: "",
      isWorkFlow: false, //是否走自定义流程
      dialogVisible: false,
      deptIdArray: [],
      moreShow: false, // 显示更多
      createTaskMeg: {
        taskName: "", //任务名称
        isEvaluter: true, // 是否是评价人
        resolved: false, // 是否已解决
        content: "", //内容描述
        funcRoom: null, //功能间信息
        man: "",
        overTimeDT: new Date().setTime(new Date().getTime() + 3600 * 1000 * 2),
        proposer: null, // 报告人
        taskLevelSel: "1",
        focusLevelSel: "2",
        createIdentitySel: "0",
        repairTime: [
          new Date(),
          new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)
        ],
        hideWindow: true, // 是否隐藏当前窗口
        taskType: null,
        solution: "",
        linkUser: "", //联系人
        ReceiveUser: {},
        ReceiveUserName: "",
        excuterUser: {}, // 接收人
        DoneDevices: [], //设备
        reportDept: null, // 选择的组织。
        taskGroup: null,
        mech: {
          // 机构信息
          ID: this.companyId,
          NAME: this.companyName
        },
        planStartDT: new Date(),
        planEndDT: new Date().setTime(new Date().getTime() + 3600 * 1000 * 2),
        firstRemindTime: "0",
        overdueTime: "0",
        firstRemindTimeUnit: "0",
        overdueTimeUnit: "0"
      },
      PM_RELATION: [],
      Relation: "",
      rules: {
        taskName: [
          {
            required: true,
            // message: '请描述您的问题',
            validator: checknum,
            trigger: "blur"
          },
          {
            min: 2,
            max: 50,
            message: "长度在 2 - 50 个字符以内",
            trigger: "blur"
          }
        ],
        ReceiveUserName: [
          {
            required: true,
            // message: '请选择接收方',
            validator: (rule, value, callback) => {
              value = this.trim(value);
              if (!value) {
                callback(new Error("请选择接收方"));
                this.time("ruleForm", "ReceiveUserName");
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        taskType: [
          {
            required: true
          }
        ]
      },
      taskTypeList: [],
      receiveUserIdArray: [], // 接收方默认的ID
      faultTypeList: [],
      noticePersonList: [],
      fileList: [],
      filePathList: [],
      filePanelHeight: {
        height: "60px"
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "两小时内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 2);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "一天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "三天内",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      // excuteHumanDisable: false,
      optionSel: {
        commomShowPlaceholder: "请选择",
        commonDialogTitle: "请选择",
        commonCheckedDescription: "已选",
        isRadio: false,
        setWidth: "100%",
        isStrictly: true //父子节点不关联
      },
      dataSel: {
        idArray: [],
        imageType: [
          {
            type: 0,
            imgPath: require("@/assets/img/BSMV/BSMVIns/机构.png")
          },
          {
            type: 51,
            imgPath: require("@/assets/img/BSMV/BSMVIns/类型.png")
          },
          {
            type: 52,
            imgPath: require("@/assets/img/BSMV/BSMVIns/厂商.png")
          },
          {
            type: 53,
            imgPath: require("@/assets/img/BSMV/BSMVIns/系列.png")
          },
          {
            type: 54,
            imgPath: require("@/assets/img/BSMV/BSMVIns/型号.png")
          },
          {
            type: 55,
            imgPath: require("@/assets/img/BSMV/BSMVIns/版本.png")
          },
          {
            type: 20,
            imgPath: require("@/assets/img/BSMV/BSMVIns/设备.png")
          },
          {
            type: 31,
            imgPath: require("@/assets/img/BSMV/BSMVIns/设备.png")
          },
          {
            type: 21,
            imgPath: require("@/assets/img/BSMV/BSMVIns/设备.png")
          },
          {
            type: 22,
            imgPath: require("@/assets/img/BSMV/BSMVIns/设备.png")
          },
          {
            type: 23,
            imgPath: require("@/assets/img/BSMV/BSMVIns/设备.png")
          },
          {
            type: 24,
            imgPath: require("@/assets/img/BSMV/BSMVIns/服务.png")
          },
          {
            type: 25,
            imgPath: require("@/assets/img/BSMV/BSMVIns/服务.png")
          },
          {
            type: 29,
            imgPath: require("@/assets/img/BSMV/BSMVIns/服务.png")
          },
          {
            type: 12,
            imgPath: require("@/assets/img/BSMV/BSMVIns/服务.png")
          },
          {
            type: 14,
            imgPath: require("@/assets/img/BSMV/BSMVIns/服务.png")
          },
          {
            type: 16,
            imgPath: require("@/assets/img/BSMV/BSMVIns/系统.png")
          },
          {
            type: 33,
            imgPath: require("@/assets/img/BSMV/BSMVIns/系统.png")
          },
          {
            type: 35,
            imgPath: require("@/assets/img/BSMV/BSMVIns/系统.png")
          },
          {
            type: 37,
            imgPath: require("@/assets/img/BSMV/BSMVIns/系统.png")
          },
          {
            type: 41,
            imgPath: require("@/assets/img/BSMV/BSMVIns/应用.png")
          },
          {
            type: 43,
            imgPath: require("@/assets/img/BSMV/BSMVIns/应用.png")
          },
          {
            type: 45,
            imgPath: require("@/assets/img/BSMV/BSMVIns/应用.png")
          },
          {
            type: 47,
            imgPath: require("@/assets/img/BSMV/BSMVIns/应用.png")
          },
          {
            type: 49,
            imgPath: require("@/assets/img/BSMV/BSMVIns/应用.png")
          }
        ],
        checkField: {
          Id: "Id",
          Pid: "Pid",
          Key: "AggrID",
          Type: "Type",
          TypeValue: [
            51,
            52,
            53,
            54,
            55,
            20,
            24,
            16,
            41,
            31,
            25,
            33,
            43,
            21,
            29,
            35,
            45,
            22,
            12,
            37,
            47,
            23,
            14,
            39,
            49
          ],
          ValidField: ["TAGNAME"],
          ShowField: "Name",
          ShowFieldName: "关键字"
        }
      },
      taskLevel: [
        {
          value: "0",
          label: "重要且紧急"
        },
        {
          value: "1",
          label: "重要不紧急"
        },
        {
          value: "2",
          label: "紧急不重要"
        },
        {
          value: "3",
          label: "不重要不紧急"
        }
      ],
      focusLevel: [
        {
          value: "0",
          label: "不关注"
        },
        {
          value: "1",
          label: "一级关注"
        },
        {
          value: "2",
          label: "二级关注"
        },
        {
          value: "3",
          label: "三级关注"
        }
      ],
      fileFormData: {
        guid: this.Guid()
      },
      isLoad: true
    };
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      ServerCenterIds: state => state.task.ServerCenterIds,
      createIdentity: state => state.task.createIdentity,
      contactId: state => state.user.ContactID,
      realName: state => state.task.realName,
      departmentId: state => state.user.departmentId,
      departmentName: state => state.user.departmentName,
      companyId: state => state.user.companyId,
      companyName: state => state.user.companyName
    }),
    taskLevelNow() {
      return this.createTaskMeg.taskLevelSel;
    },
    // 是否是故障报修类型
    isRepair() {
      return this.createTaskMeg.taskType == "f415c1c0dc62e363";
    }
  },
  mounted() {},
  created() {
    cap.Init(this); //初始化截图插件。
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initCreatTaskInfo();
      }
    },
    taskLevelNow(val) {
      GetAllTaskNoticePolicy().then(res => {
        if (!res) return;
        console.log(
          res,
          this.createTaskMeg.firstRemindTime,
          this.createTaskMeg.firstRemindTimeUnit
        );
        const noticeTime = res.filter(item => {
          return item.TASKDEGREE == val;
        });
        this.createTaskMeg.firstRemindTime = noticeTime[0].TIMENUM;
        this.createTaskMeg.firstRemindTimeUnit = noticeTime[0].TIMEUNIT.toString();
      });
    }
  },
  methods: {
    OpenDialog() {
      this.dialogVisible = true;
      setTimeout(() => {
        this.$refs.uploader.initWebUpload();
      }, 1000);
    },
    // 标题
    getValueSelectKnowledge(val) {
      this.createTaskMeg.taskName = val;
    },
    getTagByInput(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          GetTaskTag(query).then(list => {
            this.tagOptions = list.filter(item => {
              return (
                item.TAGNAME.toLowerCase().indexOf(query.toLowerCase()) > -1
              );
            });
          });
        }, 200);
      } else {
        this.tagOptions = [];
      }
    },
    getAllUser(val) {
      // 选择人员
      console.log(val);
      this.noticePersonList = val;
    },
    initCreatTaskInfo() {
      GetPubDeptByUserId(this.userId).then(result => {
        if (result) {
          this.createDeptOptions = result;
          console.log("createDeptOptions", result);
          this.createDeptId = this.departmentId;
        }
      });
      if (!this.ServerCenterIds) {
        this.$store.dispatch("changeServerCenterIds");
      }
      if (!this.createIdentity.length) {
        this.$store.dispatch("GetServerCenterByUserId");
      }
      // 初始化创建任务的信息
      this.tagOptions = [];
      this.tagArray = [];
      this.createTaskMeg.repairTime = [];
      this.createTaskMeg.repairTime.push(new Date());
      this.createTaskMeg.repairTime.push(
        new Date().setTime(new Date().getTime() + 3600 * 1000 * 2)
      );
      // 提醒
      this.createTaskMeg.planStartDT = new Date();
      this.createTaskMeg.planEndDT = new Date().setTime(
        new Date().getTime() + 3600 * 1000 * 2
      );
      this.createTaskMeg.isRemind = false;
      this.createTaskMeg.firstRemindTime = 10;
      this.createTaskMeg.overdueTime = 0;
      this.createTaskMeg.firstRemindTimeUnit = "1";
      this.createTaskMeg.overdueTimeUnit = "0";

      this.createTaskMeg.taskLevelSel = "1";
      this.createTaskMeg.focusLevelSel = "2";
      this.createTaskMeg.taskName = "";
      this.createTaskMeg.createIdentitySel = "0";
      this.createTaskMeg.resolved = false;
      this.createTaskMeg.content = "";
      this.createTaskMeg.hideWindow = true;
      this.fileList = [];
      this.initTaskType();
      setTimeout(() => {
        // this.$refs.selectFuncRoom.reset();
        // this.$refs.selectDept.reset();
        this.$refs.selectAllUser.reset();
        this.$refs.linkman.initDefaultLink(this.contactId);
        this.$refs.taskGroup.reset();
        this.$refs.ReceiveUser.reset();
        this.$refs.ReceiveUser.initDefaultCenter();
        this.$refs.editorTxt.reset();
        // this.$refs.excuteHuman.reset();
        // this.$refs.Proposer.reset();
      }, 500);
    },
    initTaskType() {
      // 初始化任务类型
      GetTaskTypeList().then(res => {
        if (res.length > 0) {
          this.taskTypeList = res.filter(item => item.CLASSID == "fuwu");
          var defaultType = this.taskTypeList.filter(a => {
            if (this.taskTypeName == "任务组") {
              return a.ID == "E9354DE41375";
            } else {
              return a.ID == "dab7a9f20898f2d8";
            }
          });
          if (defaultType.length > 0) {
            this.createTaskMeg.taskType = defaultType[0].ID;
          } else {
            this.createTaskMeg.taskType = this.taskTypeList[0].ID;
          }
        }
      });
    },
    taskTypeChange(selVal) {
      console.log("selVal", selVal);
      if (!selVal) return "";
      if (selVal === "dab7a9f20898f2d8") {
        //判断是否是自定义流程
        this.isWorkFlow = true;
      }
      //根据任务类型设置任务超期等设置
      var selectType = this.taskTypeList.filter(a => {
        return a.ID == this.createTaskMeg.taskType;
      })[0];

      this.createTaskMeg.isNotice = selectType.DELAYNOTICE;
      this.createTaskMeg.overTimeDT = new Date().setTime(
        new Date().getTime() + 3600 * 1000 * selectType.PROCCESSHOUR
      );
      this.createTaskMeg.firstRemindTime = selectType.RESPONSEHOUR;
      this.createTaskMeg.firstRemindTimeUnit = 1;
      this.createTaskMeg.overdueTime = selectType.RESPONSEHOUR;
      this.createTaskMeg.overdueTimeUnit = 1;
      // console.log(this.taskTypeList.find(d => d.ID === selVal));
    },
    GetTaskGroup(data) {
      console.info("任务组已选择:" + (data ? data.Name : "null"));
      if (data) {
        this.createTaskMeg.taskGroup = data;
      } else {
        this.createTaskMeg.taskGroup = null;
      }
    },
    toGetFuncRoomValue(data) {
      // 选择完了功能间。
      console.info(data);
      if (data.length > 0) {
        console.log("选择了功能间:" + data[0].NAME);
        this.createTaskMeg.funcRoom = data[0];
        this.createTaskMeg.mech = {
          ID: data[0].CompanyExId,
          NAME: data[0].CompanyExName
        };
        // this.$refs.selectDept.reset();
        this.deptIdArray = [];
        this.deptIdArray.push(data[0].DeptId); // 赋值到组织
      } else {
        this.createTaskMeg.funcRoom = null;
      }
    },
    deptGetValue(data) {
      // 选择了组织。
      if (data.length > 0) {
        console.log("选择了组织:" + data[0].Name);
        this.createTaskMeg.reportDept = {
          ID: data[0].ID,
          NAME: data[0].Name
        };
      } else {
        this.createTaskMeg.reportDept = null;
      }
    },
    linkmanGetValue(value) {
      // 选择的联系人
      console.log("联系人返回的信息:", value);
      this.createTaskMeg.linkUser = value;
    },
    mtGetValue(value) {
      this.faultTypeList = [];
      this.faultTypeList.push(value);
      console.log("故障类型", value);
    },
    receiverGetValue(value) {
      console.log("value", value);
      if (value.length > 0) {
        if (value[0].ContactType == 1) {
          // 如果选择的是人员 就要禁用接收人
          // this.excuteHumanDisable = true;
          // this.$refs.excuteHuman.reset();
        } else {
          // this.excuteHumanDisable = false;
        }
        this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
          ReceiveUser: value[0],
          ReceiveUserName: value[0].Name
        });
      } else {
        this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
          ReceiveUser: {},
          ReceiveUserName: ""
        });
      }
      console.log("ReceiveUser--", this.createTaskMeg.ReceiveUser);
    },
    excuteGetValue(value) {
      // 选择了接收人
      if (value) {
        this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
          excuterUser: value
        });
      } else {
        this.createTaskMeg = Object.assign({}, this.createTaskMeg, {
          excuterUser: {}
        });
      }
    },
    selectProposer(value) {
      // 报告人
      if (value) {
        this.createTaskMeg.proposer = value;
      } else {
        this.createTaskMeg.proposer = null;
      }
    },
    toGetValue(value, callback) {
      //为控件绑定值
      console.log("验证通过");
      console.log("获取的值为");
      console.log(value);
      callback(true);
    },
    SelSetValue(value, callback) {
      GetSelfCompanyEx().then(a => {
        GetCompanyAllGeneralSelTree(a.ID)
          .then(res => {
            for (let i = 0; i < res.length; i++) {
              res[i].AggrID = res[i].SocialId + "_" + res[i].Type;
            }
            callback(res);
          })
          .catch(err => {
            console.log("GetCompanyAllGeneralSelTree err");
          });
      });
    },
    SelGetValue(value, callback) {
      this.createTaskMeg.DoneDevices = value;
      console.log("选择关键字111:", value);
    },
    ShowDownLoad(content) {
      // 未安装插件提示下载
      this.$message({
        type: "warning",
        dangerouslyUseHTMLString: true,
        message: content,
        showClose: true,
        duration: 0
      });
    },
    captureStart() {
      // 截图开始
      cap.StartCapture(this.createTaskMeg.hideWindow, this);
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.warning("上传单个文件大小不能超过 1G!");
        return;
      }
      this.fileList.push(file);
      return false;
    },
    exceedUpload(file, fileList) {
      this.$message.warning("最多上传五个文件");
    },
    handleChange(file, fileList) {
      console.log(this.fileList);
    },
    setAppendContent(imgHtml) {
      this.$refs.editorTxt.setAppendContent(imgHtml);
    },
    facilityGetValue(value) {
      // 选择设备
      console.log(value);
    },
    HaveVal(val) {
      return val ? val : "";
    },
    Guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    workFlowDialog() {
      //选择流程
      this.$refs.workFlow.dialogVisible = true;
      this.$refs.workFlow.title = "选择固定流程";
      this.$refs.workFlow.workflow = {};
      this.GetCustmerSchemeInfoList();
      this.GetDataItemTree();
    },
    TimeFormat(time) {
      var newTime = new Date(time);

      function HaveZero(t) {
        return t < 10 ? "0" + t : t;
      }
      var year = newTime.getFullYear();
      var month = HaveZero(newTime.getMonth() + 1);
      var day = HaveZero(newTime.getDate());
      var hours = HaveZero(newTime.getHours());
      var min = HaveZero(newTime.getMinutes());
      var sec = HaveZero(newTime.getSeconds());
      return `${year}-${month}-${day}T${hours}:${min}:${sec}`;
    },
    GetCustmerSchemeInfoList() {
      GetCustmerSchemeInfoList()
        .then(res => {
          console.log(res);
          if (res) {
            this.$refs.workFlow.SchemeList = this.$refs.workFlow.CustmerSchemeList = res;
          }
        })
        .catch(err => {
          this.$message.error("自定义流程报错" + err);
        });
    },
    GetDataItemTree() {
      GetDataItemTree("FlowSort")
        .then(res => {
          // console.log(res)
          if (res) {
            this.$refs.workFlow.dataItemTree = res;
          }
        })
        .catch(err => {
          this.$message.error("自定义流程报错" + err);
        });
    },
    Process(row) {
      // this.title = '新建报修' + '-' + row.F_Name;
      this.processId = row.F_Code;
      this.workflowName = row.F_Name;
    },
    tagClose() {
      this.processId = "";
      this.workflowName = "";
    },
    reportStart() {
      // 开始上报准备
      var reportData = {}; //上报的数据用这个
      if (!this.createTaskMeg.taskName) {
        this.$message.warning("请填写标题!");
        return false;
      }
      if (!this.createTaskMeg.taskName.length > 50) {
        this.$message.warning("标题限制字数为50字!");
        return false;
      }
      var guid = this.Guid();
      const date = new Date();
      reportData.ID = guid.replace(/-/g, "").substring(0, 16); // 任务ID
      // reportData.ISMONITOR=true;
      reportData.CREATESOURCE = 3; // 创建来源
      reportData.CREATEUSERID = reportData.PROPOSERID = this.userId;
      reportData.CREATEUSERNAME = reportData.PROPOSERNAME = this.realName;
      reportData.PROPOSERDEPTID = this.departmentId;
      reportData.PROPOSERDEPTNAME = this.departmentName;

      reportData.CUSTOMERID = this.createTaskMeg.mech.ID; // 客户机构ID
      reportData.CUSTOMERNAME = this.createTaskMeg.mech.NAME; // 客户机构名称
      //创建科室
      reportData.CREATEDEPTID = reportData.CREATEDEPTNAME = reportData.CREATECOMPANYID = reportData.CREATECOMPANYNAME =
        "";
      if (this.createDeptId) {
        let curDeptInfo = this.createDeptOptions.find(
          item => item.ID == this.createDeptId
        );
        reportData.CREATEDEPTID = curDeptInfo.ID;
        reportData.CREATEDEPTNAME = curDeptInfo.NAME;
        reportData.CREATECOMPANYID = curDeptInfo.ORGANIZATIONID;
      }

      //////////////页面数据依次排列
      if (this.createTaskMeg.funcRoom && this.createTaskMeg.funcRoom.ID) {
        //   功能间ID
        reportData.FUNCROOMID = this.createTaskMeg.funcRoom.ID;
      } else {
        reportData.FUNCROOMID = "";
      }
      // reportData.LINKADDRESS = this.$refs.selectFuncRoom.funcRoomName; // 联系地址。
      // if (this.$refs.selectDept.selectedDept.length > 0) {
      //   this.createTaskMeg.reportDept = this.$refs.selectDept.selectedDept[0];
      // }
      if (this.createTaskMeg.reportDept) {
        // 上报组织
        reportData.CUSTOMERDEPTID = this.createTaskMeg.reportDept.ID;
        reportData.CUSTOMERDEPTNAME = this.createTaskMeg.reportDept.Name;
      }
      var linkUser = this.createTaskMeg.linkUser;
      if (linkUser.ID) {
        //如果是选的联系人。
        reportData.LINKMAN = linkUser.ID; //联系人ID
        if (linkUser.PHONE && linkUser.NAME.indexOf(linkUser.PHONE) != -1) {
          //如果联系人名字里包含了手机号就把手机号设为空
          linkUser.NAME = linkUser.NAME.replace(linkUser.PHONE, "");
        } else {
          //联系人号码
          reportData.LINKPHONE = this.HaveVal(linkUser.PHONE);
        } //联系人名称要特殊处理。
        reportData.LINKMANNAME =
          linkUser.NAME +
          "," +
          this.HaveVal(linkUser.PHONE) +
          "," +
          this.HaveVal(linkUser.POST) +
          "," +
          (linkUser.GRADE ? linkUser.GRADE + "(重要级别)" : "");
      } else {
        reportData.LINKMAN = ""; //手动输入的则自己为准。
        reportData.LINKPHONE = "";
        reportData.LINKMANNAME = linkUser;
      }
      reportData.TASKDEGREE = this.createTaskMeg.taskLevelSel; // 任务重要度

      if (this.createTaskMeg.taskGroup) {
        // 任务组
        reportData.TaskGroupName = this.createTaskMeg.taskGroup.NODENAME;
        reportData.TaskGroupId = this.createTaskMeg.taskGroup.NODEID;
      }
      reportData.FOCUSDEGREE = this.createTaskMeg.focusLevelSel; // 任务关注度
      reportData.EVENTNAME = this.createTaskMeg.taskName; // 标题
      var ident = this.createTaskMeg.createIdentitySel;
      if (ident.CENTERNAME == "个人") {
        // 创建身份
        reportData.CREATESERVERCENTERID = ident.CENTERNAME;
        reportData.CREATESERVERCENTERNAME = ident.SERVERCENTERID;
      }
      ///////选择接收方 / 接收人  开始
      var receiverUser = this.createTaskMeg.ReceiveUser;
      console.log(receiverUser);
      console.log(receiverUser, "receiverUser");
      if (!this.processId && !receiverUser.ID) {
        //!receiverUser.ID && this.type === 1
        this.$message.warning("请选择一个接收方!");
        return false;
      }
      var excuterUser = this.createTaskMeg.excuterUser;
      var selectedExcuteUser = null;
      if (receiverUser.ContactType == 1) {
        // 选择的是运维人员
        selectedExcuteUser = {
          ID: receiverUser.Key,
          NAME: receiverUser.Remarks,
          TELEPHONE: "",
          DEPTID: receiverUser.ParentKey,
          DEPTNAME: receiverUser.ParentName
        };
        reportData.SERVERCENTERID = "";
        reportData.SERVERCENTERNAME = "";
      } else {
        reportData.SERVERCENTERID = receiverUser.Key;
        reportData.SERVERCENTERNAME = receiverUser.Name;
        if (excuterUser && excuterUser.ID) {
          selectedExcuteUser = excuterUser;
        }
      }
      if (selectedExcuteUser) {
        // 接收人赋值。
        reportData.EXCUTEDEPTID = selectedExcuteUser.DEPTID;
        reportData.EXCUTEDEPTNAME = selectedExcuteUser.DEPTNAME;
        reportData.EXCUTEUSERID = selectedExcuteUser.ID;
        reportData.EXCUTEUSERNAME = selectedExcuteUser.NAME;
        reportData.EXCUTEUSERPHONE = selectedExcuteUser.TELEPHONE
          ? selectedExcuteUser.TELEPHONE
          : "";
      } else {
        reportData.EXCUTEDEPTID = reportData.EXCUTEDEPTNAME = reportData.EXCUTEUSERID = reportData.EXCUTEUSERNAME = reportData.EXCUTEUSERPHONE =
          "";
      }
      ///////////接收方接收
      if (this.createTaskMeg.taskType) {
        // 任务类型
        var selectType = this.taskTypeList.filter(a => {
          return a.ID == this.createTaskMeg.taskType;
        });
        var taskType = selectType[0];
        reportData.EVENTTYPE = taskType.ID;
        reportData.EVENTCLASS = taskType.CLASSID;
        reportData.EVENTTYPENAME = taskType.NAME;
      }
      if (this.createTaskMeg.resolved) {
        // 如果点了已解决  ->  赋值解决方案。
        reportData.EXCUTEUSERREPLY = this.createTaskMeg.solution;
      }

      if (this.createTaskMeg.resolved && !this.createTaskMeg.solution) {
        //!receiverUser.ID && this.type === 1
        this.$message.warning("请输入解决方案!");
        return false;
      }

      if (this.createTaskMeg.resolved && !selectedExcuteUser) {
        // 勾选了已解决，必须要接收人
        this.$message.warning("请选择接收人!");
        return false;
      }

      reportData.CONTENT = this.createTaskMeg.content; // 报修内容
      var proposer = this.createTaskMeg.proposer;
      if (proposer) {
        reportData.PROPOSERID = proposer.ID;
        reportData.PROPOSERNAME = proposer.NAME;
        reportData.PROPOSERDEPTID = proposer.DEPTID;
        reportData.PROPOSERDEPTNAME = proposer.DEPTNAME;
      }
      reportData.STATE = 0;
      reportData.EFFECTDEGREE = 0;
      reportData.EMERGENCEDREGEE = 0;
      reportData.CREATETIME = date;
      // reportData.REPAIRTIME1 = this.TimeFormat(
      //   this.createTaskMeg.repairTime[0]
      // );
      // reportData.REPAIRTIME2 = this.TimeFormat(
      //   this.createTaskMeg.repairTime[1]
      // );
      // 提醒

      if (this.createTaskMeg.isNotice) {
        reportData.OVERTIMENOTICE = this.createTaskMeg.isNotice; // 进度逾期提醒
        // 计划开始时间 结束时间
        reportData.REPAIRTIME1 = reportData.BEGINDATE = this.TimeFormat(
          this.createTaskMeg.planStartDT
        );
        reportData.REPAIRTIME2 = reportData.ENDDATE = this.TimeFormat(
          this.createTaskMeg.planEndDT
        );
        reportData.OVERTIME = this.TimeFormat(this.createTaskMeg.overTimeDT); // 任务到期时间
      }
      reportData.RESPONSENOTICE = this.createTaskMeg.isRemind; // 操作超期提醒
      if (!/^\d+$/.test(this.createTaskMeg.firstRemindTime)) {
        this.$message.warning("“接收时长”应为数值");
        return false;
      }
      let firstRemindTime = parseInt(this.createTaskMeg.firstRemindTime);
      reportData.FIRSTRESPONSENUM = firstRemindTime;
      reportData.FIRSTRESPONSEUNIT = this.createTaskMeg.firstRemindTimeUnit;
      if (!/^\d+$/.test(this.createTaskMeg.overdueTime)) {
        this.$message.warning("“逾期提醒周期”应为数值");
        return false;
      }
      let overdueTime = parseInt(this.createTaskMeg.overdueTime);
      reportData.RESPONSENUM = overdueTime;
      reportData.RESPONSEUNIT = this.createTaskMeg.overdueTimeUnit;
      if (this.processId) {
        reportData.WORKFLOWID = this.Guid();
      }
      reportData.DeviceList = [];
      //////处理设备对象相关数据
      if (this.createTaskMeg.DoneDevices.length > 0) {
        // 设备。
        this.createTaskMeg.DoneDevices.forEach(c => {
          c.TASKID = reportData.ID;
          c.NAME = c.Name;
          c.DEVTYPENAME = c.DevTypeName;
          c.SOCIALID = c.SocialId;
          c.SOCIALTYPE = parseInt(c.SocialId.substr(c.SocialId.length - 1, 1));
          c.OBJID = c.ObjID;
          c.BRANDCODE = c.BrandCode;
          c.BRANDSHOWNAME = c.BrandShowName;
          c.SERIAL = c.Serial;
          c.MODE = c.Model;
          c.VERSION = c.VersionName;
          c.LOCATION = c.AreaName + c.BuildingName + c.StoreyName + c.RoomName;
          c.Id = 0;
        });
        reportData.DeviceList = this.createTaskMeg.DoneDevices;
      }
      reportData.FaultTypeList = [];
      if (this.faultTypeList.length > 0) {
        // 设备。
        this.faultTypeList.forEach(c => {
          c.TASKID = reportData.ID;
          c.FAULTTYPE = c.ID;
          // c.ID = 0
        });
        this.faultTypeList.forEach(c => {
          c.ID = 0;
          c.Id = 0;
        });
        reportData.FaultTypeList = this.faultTypeList;
      }
      //console.info(reportData)
      //reportData.EVENTDEVICES = [];
      var formData = new FormData();
      // if (this.fileList.length > 0) {
      //   for (var i = 0; i < this.fileList.length; i++) {
      //     formData.append(i.toString(), this.fileList[i].source.source);
      //   }
      // }
      formData.append("FilePathList", JSON.stringify(this.filePathList));
      reportData.TagList = this.tagArray;
      reportData.NoticePersonList = [];
      reportData.ChatGroupId = this.groupId;
      if (this.noticePersonList.length > 0) {
        this.noticePersonList.forEach(c => {
          reportData.NoticePersonList.push({
            USERID: c.UserId,
            USERNAME: c.Name,
            DEPTID: c.DeptID,
            DEPTNAME: c.DeptName,
            TASKID: reportData.ID,
            ISNOTICEPERSON: true,
            ALLOWCREATESUBTASK: true,
            ISEVALUTIONPERSON: false
          });
        });
      }
      console.log(reportData.NoticePersonList, "通知提醒人");
      if (this.type === 1) {
        formData.append("DeviceList", JSON.stringify(reportData.DeviceList));
        formData.append(
          "FaultTypeList",
          JSON.stringify(reportData.FaultTypeList)
        );
        formData.append(
          "NoticePersonList",
          JSON.stringify(reportData.NoticePersonList)
        );
        formData.append("SolveMySelf", this.createTaskMeg.resolved);
        console.log("reportData", reportData);
        this.PM_RELATION.LINKID = reportData.ID;
        this.PM_RELATION.LINKSTATE = reportData.STATE;
        if (this.Relation === 1) {
          reportData.Relation = this.PM_RELATION;
        }
        formData.append("EventInfo", JSON.stringify(reportData));
        // this.$emit("getValue", reportData)
        const loading = this.$loading({
          lock: true
        });
        setTimeout(() => {
          loading.close();
        }, 8000);
        AddEvent(formData)
          .then(res => {
            loading.close();
            if (res == 1) {
              this.$message({
                message: "创建事项成功!",
                type: "success"
              });
              this.$emit("getValue", reportData);
              this.initCreatTaskInfo();
              // if (this.type1 !== "3") this.$store.dispatch("changeTaskSource");
              // else this.$store.dispatch("GetTaskGroupTaskList");
              this.dialogVisible = false;
            } else {
              this.$message.error("报修失败");
              console.error("报修失败", res);
            }
          })
          .catch(err => {
            this.$message.error("报修失败" + err);
            console.error("报修失败", err);
          });
      } else {
        let currentTask = this.$store.state.task.curTask;

        reportData.EVALUTIONTIME = date;
        reportData.PROPOSERID = currentTask.PROPOSERID;
        reportData.PROPOSERNAME = currentTask.PROPOSERNAME;
        reportData.PROPOSERDEPTID = currentTask.PROPOSERDEPTID;
        reportData.PROPOSERDEPTNAME = currentTask.PROPOSERDEPTNAME;
        reportData.PROPOSERCOMPANYID = currentTask.PROPOSERCOMPANYID;
        reportData.PROPOSERCOMPANYNAME = currentTask.PROPOSERCOMPANYNAME;
        reportData.PARENTID = currentTask.ID;
        reportData.EVENTINSTANCE = currentTask.EVENTINSTANCE;
        reportData.EVENTID = currentTask.EVENTID;
        reportData.EVENTNAME = currentTask.EVENTNAME;
        reportData.ROOTID = currentTask.ROOTID;
        reportData.PARENTNAME = currentTask.TASKNAME;
        reportData.TASKNAME = this.createTaskMeg.taskName;
        reportData.BEGINDATE = reportData.REPAIRTIME1;
        reportData.ENDDATE = reportData.REPAIRTIME2;
        let jsonData = {
          USERID: this.userId,
          USERNAME: this.realName,
          DEPTID: this.departmentId,
          DEPTNAME: this.departmentName,
          TASKID: currentTask.ID,
          ISNOTICEPERSON: false,
          ALLOWCREATESUBTASK: false,
          ISEVALUTIONPERSON: true
        };
        formData.append("TaskInfo", JSON.stringify(reportData)); //任务信息
        formData.append("TaskMeMberInfo", JSON.stringify(jsonData)); //子任务信息
        AddAssignFileTask(formData).then(pmevent => {
          if (pmevent === 1) {
            this.$message({
              type: "success",
              message: "添加服务申请成功。"
            });
            this.initCreatTaskInfo();
            if (this.type1 !== "3") this.$store.dispatch("changeTaskSource");
            else this.$store.dispatch("GetTaskGroupTaskList");
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: "添加服务申请失败！"
            });
            this.isDisabled = false;
          }
        });
      }
      // console.log(this.createTaskMeg.ReceiveUser);
      if (this.processId) {
        let auditers = {
          // userId: this.createTaskMeg.ReceiveUser.Key,
          // userName: this.createTaskMeg.ReceiveUser.Name,
        };
        let createUser = {
          userId: this.userId,
          realName: this.realName,
          companyId: this.companyId,
          departmentId: this.departmentId
        };
        workflowCreate(
          true,
          reportData.WORKFLOWID,
          this.processId,
          this.createTaskMeg.taskName,
          1,
          this.createTaskMeg.content,
          JSON.stringify(createUser),
          JSON.stringify(auditers),
          "{}"
        )
          .then(res => {
            if (res.status === 1) {
              this.$message({
                message: res.desc,
                type: "success"
              });
            } else {
              this.$message({
                message: res.desc,
                type: "error"
              });
            }
          })
          .catch(err => {
            this.$message.error("自定义流程报错" + err);
            console.error(err);
          });
      }
    },
    cancelDialog() {
      this.initCreatTaskInfo();
      if (this.IsShowOnlyList) {
        parent.setFullScreen(false);
      }
      this.$refs.uploader.destroy();
    },
    onRemindChange(val) {
      this.createTaskMeg.isRemind = val;
    },
    onNoticeChange(val) {
      this.createTaskMeg.isNotice = val;
    },
    fileChange(file) {
      if (!file.size) return;
      this.fileList.push(file);

      this.filePanelHeight = {
        height: this.fileList.length * 60 + "px"
      };
      console.log(file);
    },
    onProgress(file, percent) {
      $(`.file-${file.id} .progress`).css("width", percent * 100 + "%");
      $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + "%");
    },
    fileUploadCompleted(file, response) {
      console.log("合并" + file.name, response);
      console.log("上传合并", file.name + ":" + response.guid);
      MergeFile(response.guid, response.f_ext).then(data => {
        console.log("合并：", data);
        if (data) {
          this.filePathList.push(data);
        } else {
          this.$message.error("文件合并失败！");
        }
      });
    },
    fileCategory(ext) {
      let type = "";
      const typeMap = {
        image: ["gif", "jpg", "jpeg", "png", "bmp", "webp"],
        video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
        text: [
          "doc",
          "txt",
          "docx",
          "pages",
          "epub",
          "pdf",
          "numbers",
          "csv",
          "xls",
          "xlsx",
          "keynote",
          "ppt",
          "pptx"
        ]
      };
      Object.keys(typeMap).forEach(_type => {
        const extensions = typeMap[_type];
        if (extensions.indexOf(ext) > -1) {
          type = _type;
        }
      });
      return type;
    },
    fileSize(size) {
      return WebUploader.Base.formatSize(size);
    },
    resume(file) {
      this.$refs.uploader.upload(file);
    },
    stop(file) {
      this.$refs.uploader.stop(file);
    },
    remove(file) {
      // 取消并中断文件上传
      this.$refs.uploader.cancelFile(file);
      // 在队列中移除文件
      this.$refs.uploader.removeFile(file, true);

      // 在ui上移除
      let index = this.fileList.findIndex(ele => ele.id === file.id);
      this.fileList.splice(index, 1);
      this.filePathList.splice(index, 1);
      this.filePanelHeight = {
        height: this.fileList.length * 60 + "px"
      };
    }
  }
};
</script>

<style lang="less" scoped>
.isActiveClass {
  transform: rotate(90deg);
}

.createTaskDialog {
  .el_dialog__footer {
    padding: 0px 10px 10px;
  }

  .el-dialog__body {
    padding: 0px 20px;
    overflow-y: auto;
    max-height: 80vh;
  }

  .el-dialog__header {
    text-align: left;
    padding: 10px 10px 10px;
  }

  .el-col {
    margin-top: 0px;
    // padding-right: 20px;
    padding-left: 10px;
  }

  height: 100%; // overflow: hidden;

  .el-form {
    text-align: left;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .rightPadding {
    box-sizing: border-box;
    // padding-right: 20px;
  }

  .selectInput {
    display: inline-block;
  }

  .workFlow {
    margin-right: 20px;
    color: red;
    font-size: large;
  }

  .list {
    max-height: 600px;
  }

  .createTaskForm {
    margin-bottom: 20px;
    width: 99%;
  }

  .el-form-item__content {
    .el-col {
      margin-top: 0px;
      padding-left: 0px;
    }
  }
}

#CreateTaskFilePicker {
  font-size: 12px;
  line-height: normal;
}

.file-panel {
  width: 840px;
  margin-top: 10px;
  box-shadow: 0 2px 12px 1px rgba(0, 0, 0, 0.1);

  > h2 {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
  }

  .file-list {
    position: relative;
    height: 60px;
    // overflow-y: auto;
    background-color: rgb(250, 250, 250);
  }

  .file-item {
    position: relative;
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    border-bottom: 1px solid #ccc;
    background-color: #fff;
    z-index: 1;

    > li {
      display: inline-block;
    }
  }

  .file-item li {
    overflow: hidden;
  }

  .file-type {
    width: 24px;
    height: 24px;
    margin-bottom: 18px;
    vertical-align: -5px;
  }

  .file-name {
    width: 40%;
    margin-left: 10px;
  }

  .fileName {
    overflow: hidden;
    /*内容超出宽度时隐藏超出部分的内容 */
    text-overflow: ellipsis;
    /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
    white-space: nowrap;
    /*不换行 */
  }

  .file-size {
    width: 20%;
  }

  .file-status {
    width: 20%;
  }

  .file-operate {
    width: 10%;

    > a {
      padding: 10px 5px;
      cursor: pointer;
      color: #666;

      &:hover {
        color: #ff4081;
      }
    }
  }

  .file-type[icon="text"] {
    background: url(../../../assets/img/icon/text-icon.png);
  }

  .file-type[icon="video"] {
    background: url(../../../assets/img/icon/video-icon.png);
  }

  .file-type[icon="image"] {
    background: url(../../../assets/img/icon/image-icon.png);
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    width: 0;
    background-color: #e2edfe;
    z-index: -1;
  }

  .no-file {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
  }
}
</style>
